// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:55a98ca2-dda7-4711-9f61-fc2dd228151a",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_AOpHETxSU",
    "aws_user_pools_web_client_id": "mqf1hekas6mvbbsst9ffne1nt"
};


export default awsmobile;
